import { TeamConfig } from "@/global/hooks/useTeamConfig";
import { EventType } from "@/global/store/data/types";

export function validateEventByMaxSeatLimit(
  evt: EventType,
  teamConfig: TeamConfig
) {
  const {
    purchaseSeatConfigs: { minSeatLimit },
  } = teamConfig;
  const { maxSeatLimit, seatsClaimed } = evt;
  if (seatsClaimed == null || seatsClaimed == undefined) return true;
  if (maxSeatLimit - seatsClaimed >= minSeatLimit) return true;
  return false;
}

export function getEventsAboveMaxLimit(
  events: EventType[],
  teamConfig: TeamConfig
) {
  return events.filter((evt) => !validateEventByMaxSeatLimit(evt, teamConfig));
}

export function getEventsBelowMaxLimit(
  events: EventType[],
  teamConfig: TeamConfig
) {
  return events.filter((evt) => validateEventByMaxSeatLimit(evt, teamConfig));
}
